import { styled, Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export const Container = styled(Box)({
  width: '100%',
  overflowX: 'hidden',
  backgroundColor: '#FFFFFF',
  borderRadius: '8px',
});

export const Inner = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  paddingLeft: 8,
  paddingRight: 8,
  position: 'relative',
  width: '100%',
});

export const StepWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  position: 'relative',
});

export const ClickableBox = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isCompleted' &&
    prop !== 'isActive' &&
    prop !== 'isInactive' &&
    prop !== 'isClickable',
})<{
  isCompleted: boolean;
  isActive: boolean;
  isInactive: boolean;
  isClickable: boolean;
}>(({ isCompleted, isActive, isInactive, isClickable }) => ({
  width: '100%',
  minWidth: 0,
  backgroundColor: isActive ? '#FCFEFF' : '#FFFFFF',
  border: isActive ? '1px solid #D9F1FF' : '1px solid transparent',
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  paddingTop: '4px',
  paddingBottom: '7.54px',
  paddingLeft: 8,
  paddingRight: 8,
  cursor: isClickable ? 'pointer' : 'default',
  opacity: isInactive ? 0.6 : 1,
  transition: 'all 0.3s ease',
  position: 'relative',
  zIndex: 1,
  '&:hover': {
    backgroundColor: isClickable
      ? isActive
        ? '#F1F7FF'
        : '#F5F5F5'
      : '#FFFFFF',
  },
}));

export const TopRow = styled(Box)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '20px',
  marginBottom: '7.33px',
});

export const LeftConnector = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ isActive }) => ({
  position: 'absolute',
  right: '50%',
  left: '-16px',
  top: '50%',
  transform: 'translateY(-50%)',
  height: '2px',
  backgroundColor: isActive ? '#0F52BA' : '#DFDFDF',
  transition: 'background-color 0.3s ease',
}));

export const RightConnector = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ isActive }) => ({
  position: 'absolute',
  left: '50%',
  right: '-16px',
  top: '50%',
  transform: 'translateY(-50%)',
  height: '2px',
  backgroundColor: isActive ? '#0F52BA' : '#DFDFDF',
  transition: 'background-color 0.3s ease',
}));

export const Circle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompleted' && prop !== 'isActive',
})<{ isCompleted: boolean; isActive: boolean }>(
  ({ isCompleted, isActive }) => ({
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: isCompleted
      ? 'none'
      : isActive
      ? '2px solid #0F52BA'
      : '2px solid #DFDFDF',
    backgroundColor: isCompleted ? '#0F52BA' : '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    zIndex: 1,
  })
);

export const StyledCheckIcon = styled(CheckIcon)({
  fontSize: '14px',
  color: '#FFFFFF',
});

export const ActiveDot = styled(Box)({
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  backgroundColor: '#0F52BA',
});

export const Label = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isCompleted' && prop !== 'isActive',
})<{ isCompleted: boolean; isActive: boolean }>(
  ({ isCompleted, isActive }) => ({
    fontFamily: 'Outfit',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '100%',
    color: isCompleted ? '#0B2330' : isActive ? '#0F52BA' : '#0B2330',
    textAlign: 'center',
    marginBottom: '3.13px',
  })
);

export const Description = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: 300,
  fontSize: '12px',
  lineHeight: '100%',
  color: '#75838A',
  textAlign: 'center',
});
